const { AzureOpenAI } = require("openai");

const endpoint = process.env.REACT_APP_AZURE_OPENAI_ENDPOINT;
const TxtEndpoint = process.env.REACT_APP_AZURE_OPENAI_ENDPOINT;
const apiKey = process.env.REACT_APP_AZURE_OPENAI_API_KEY;
// Required Azure OpenAI deployment name and API version For Dall-E
const apiVersion = "2024-04-01-preview";
const deploymentName = "dall-e-3";

// Required Azure OpenAI deployment name and API version For Dall-E
const GPTapiVersion = "2024-05-01-preview";
const GPTdeploymentName = "gpt-4o-mini";

// The prompt to generate images from
const Iterration = 2;

class AIClientImpl {
	getImageClient() {
		return new AzureOpenAI({
			endpoint: process.env.REACT_APP_AZURE_OPENAI_IMAGES,
			apiKey,
			apiVersion,
			deployment: deploymentName,
			dangerouslyAllowBrowser: true, // disable this in production
		});
	}
	getChatClient() {
		return new AzureOpenAI({
			endpoint: TxtEndpoint,
			apiKey,
			apiVersion: GPTapiVersion,
			dangerouslyAllowBrowser: true, // disable this in production
		});
	}
	async summarizeText(prompt, token) {
		const Chatclient = this.getChatClient();
		const response = await Chatclient.chat.completions.create({
			model: GPTdeploymentName,
			messages: prompt,
			max_tokens: token,
			temperature: 0.8,
			top_p: 0.9,
			frequency_penalty: 0.1,
			presence_penalty: 0.1,
			stop: null,
			stream: false,
		});

		if (
			response.choices &&
			response.choices.length > 0 &&
			response.choices[0].message
		) {
			return response.choices[0].message.content.trim();
		} else {
			throw new Error("Failed to summarize text");
		}
	}

	async createImages(summarizedPrompt) {
		const allImages = [];

		for (let i = 0; i < Iterration; i++) {
			const client = this.getImageClient();

			const requestBody = {
				prompt: summarizedPrompt,
				size: "1024x1024",
				n: 1,
				model: deploymentName,
				quality: "hd",
				style: "vivid",
				response_format: "url",
			};

			const results = await client.images.generate(requestBody);
			allImages.push(...results.data);
		}
		return allImages;
	}
}

export const AIService = new AIClientImpl();
